import { useShortUrl, useTaskSetting } from '@app/api';

export const useRedirectCompletionLink = (id?: string) => {
  const shortUrl = useShortUrl();
  const { data: unmoderatedTaskSetting } = useTaskSetting(id);
  if (!unmoderatedTaskSetting || !('finishedCode' in unmoderatedTaskSetting)) {
    return null;
  }
  return `${shortUrl}/study/finish/${unmoderatedTaskSetting.finishedCode}`;
};
